import { Stack } from '@mui/material';
import React from 'react'
import { Helmet } from 'react-helmet-async';
import { UpdateProfile } from '../../common/update-profile';

function AdminProfile() {
  return (
    <>
    <Helmet><title>BVT Admin - Profile</title></Helmet>
    <Stack spacing={3}>
      <UpdateProfile/>
    </Stack>
    </>
  )
}

export default AdminProfile